import React from 'react';

function Refresh(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M19.63 3.375C19.9752 3.375 20.255 3.65482 20.255 4V9.71875C20.255 10.0639 19.9752 10.3438 19.63 10.3438H13.9375C13.5923 10.3438 13.3125 10.0639 13.3125 9.71875C13.3125 9.37357 13.5923 9.09375 13.9375 9.09375H18.2238C16.9731 6.84996 14.5712 5.32812 12.0312 5.32812C8.21703 5.32812 5.125 8.42016 5.125 12.2344C5.125 16.0486 8.21703 19.1406 12.0312 19.1406C13.964 19.1406 15.7104 18.3475 16.9647 17.0674C17.2062 16.8208 17.602 16.8168 17.8485 17.0583C18.0951 17.2999 18.0991 17.6956 17.8575 17.9422C16.3779 19.4524 14.3136 20.3906 12.0312 20.3906C7.52668 20.3906 3.875 16.7389 3.875 12.2344C3.875 7.7298 7.52668 4.07812 12.0312 4.07812C14.8526 4.07812 17.4809 5.6383 19.005 7.97181V4C19.005 3.65482 19.2848 3.375 19.63 3.375Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Refresh;
